function lhnJsSdkEmbeddedOpened() {
    // This function will be called when the embedded window is opened
    // NOTE: !!!!!!!!!!!!!!!!!!!!!!!! this is only included for future reference !!!!!!!!!!!!!!!!!!!!!!!!!
    // do we need to set initial focus to something inside the embedded chat window?
    // IF SO, or we need to do other manipulations to the LH popup, it should go here most likely
  }

  function lhnJsSdkEmbeddedClosed() {
    if (
      document.getElementById("openLiveChatBtn")
    ) {
      document.getElementById("openLiveChatBtn").focus();
    }
  }

  function HandleChatPopup() {
    if (lhnJsSdk &&
      document
        .getElementById("lhnHelpOutCenter") &&
      document
        .getElementById("lhnHelpOutCenter").classList.contains("lhnActive")
    ) {
      // chat popup is open so close it
      lhnJsSdk.closeHOC();
    } else {
      // open the embedded chat popup
      lhnJsSdk.openHOC();
    }
  }

function doLiveChat() {
    if (
      document.getElementById("lhnHocButton") === undefined ||
      document.getElementById("lhnHocButton") == null
    ) {
      // Pull the LiveHelpNow SDK credentials from the API (sourced from appsettings)
      // every time chat is launched, so secrets are never hardcoded in source.
      fetch("/api/user/LiveChatConfig", {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Failed to load Live Chat configuration: " + response.status);
          }
          return response.json();
        })
        .then(function (lhnConfig) {
          if (
            !lhnConfig ||
            !lhnConfig.applicationId ||
            !lhnConfig.applicationSecret ||
            !lhnConfig.controlId
          ) {
            console.error("LiveHelpNow SDK configuration is missing.");
            return;
          }
          window.lhnJsSdkInit = function () {
            lhnJsSdk.setup = {
              application_id: lhnConfig.applicationId,
              application_secret: lhnConfig.applicationSecret
            };
            lhnJsSdk.controls = [{
              type: "hoc",
              id: lhnConfig.controlId
            }];
          };

          (function (d, s) {
            var lhnjs = d.getElementsByTagName(s)[0];
            var newjs = d.createElement(s);
            newjs.src =
              "https://developer.livehelpnow.net/js/sdk/lhn-jssdk-current.min.js";
            lhnjs.parentNode.insertBefore(newjs, lhnjs);
          })(document, "script");
        })
        .catch(function (error) {
          console.error("Unable to initialize Live Chat.", error);
        });
    }
  }
